import React, {useEffect, useRef, useState} from 'react';
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil';
import {useNavigate} from 'react-router-dom';
import {Capacitor} from '@capacitor/core';
import {useTranslation} from 'react-i18next';

import Layout from '@/layouts';
import AlarmBanner from '@/components/Brand/AlarmBanner';
import BenefitCard from '@/components/Brand/BenefitCard';
import {UserInfo, user} from '@/store/user';
import NoBenefit from '@/components/Brand/NoBenefit';
import {ToastMessage, isOpenToast} from '@/store';
import BookMarkModal from '@/components/brandAlertModal/BookMarkModal';
import {likeBrand} from '@/services/brands';
import {BrandListItems} from '@/store/brand';
import {isMobile} from '@/utils';

import styles from './styles.module.scss';

interface Props {
  info: BrandListItemType | undefined;
  openMarketingModal: (is: boolean) => void;
  benefits: CollectionListItem[];
  reload: (_brandInfo: BrandListItemType) => void;
}

export default function BenefitView({
  info,
  openMarketingModal,
  benefits,
  reload,
}: Props) {
  const accessToken = useRecoilValue(user);
  const userInfo = useRecoilValue(UserInfo);
  const navigator = useNavigate();
  const [brandItems, setBrandItems] = useRecoilState(BrandListItems);
  const [isAgree, setIsAgree] = useState(true);
  const [isOpenBookmarkModal, setIsOpenBookMarkModal] = useState(false);
  const carouselRef = useRef<HTMLDivElement>(null);
  const [likePopupId, setLikePopupId] = useState(0);
  const setToastMessage = useSetRecoilState(ToastMessage);
  const setOpenToastModal = useSetRecoilState(isOpenToast);
  const {t} = useTranslation(['views'], {keyPrefix: 'BenefitView'});

  const updateBrandItems = (isBookmark: boolean) => {
    const _brandItems = JSON.parse(JSON.stringify(brandItems));
    _brandItems.forEach((bi: BrandListItemType) => {
      if (bi.id === info?.id) {
        bi.isBookmark = isBookmark;
      }
    });
    setBrandItems(_brandItems);
  };
  const checkPermissionAgree = async () => {
    setIsAgree(userInfo.isMarketing || false);
  };
  const doLike = async () => {
    if (!accessToken) {
      navigator('/login', {
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      });
      return;
    }
    if (info) {
      await likeBrand(accessToken, info?.parentId, !info?.isBookmark);
      updateBrandItems(!info?.isBookmark);
      if (!info?.isBookmark === true) {
        setToastMessage(t('bookmarkMsg'));
        setOpenToastModal(true);
      }
      const _info = JSON.parse(JSON.stringify(info));
      _info.isBookmark = !_info.isBookmark;
      reload(_info);
    }
  };
  useEffect(() => {
    checkPermissionAgree();
  }, [userInfo]);
  return (
    <Layout.BrandCardView title={t('title')} description={t('desc')}>
      <div style={{padding: '0 0 60px 0'}}>
        {
          <div className={styles.carousel}>
            <div className={styles.items} ref={carouselRef} id={'carousel'}>
              {benefits.length > 0 ? (
                benefits.map(benefit => {
                  return (
                    <BenefitCard
                      key={benefit.id}
                      isComingSoon={benefit.status === '2_before_open'}
                      isSoldout={benefit.status === '1_sold_out'}
                      item={benefit}
                      clickCallback={(_callback: () => void, id?: number) => {
                        console.log(benefit);
                        if (
                          benefit.status !== '1_opened' &&
                          benefit.status !== '1_sold_out'
                        ) {
                          return;
                        }
                        console.log(info);
                        if (!info?.isBookmark) {
                          console.log(456);
                          setIsOpenBookMarkModal(true);
                          setLikePopupId(id || 0);
                        } else {
                          _callback();
                        }
                      }}
                    />
                  );
                })
              ) : (
                <div style={{padding: '0 20px', width: '100%'}}>
                  <NoBenefit backgroundImg={info?.imageList[0] || ''} />
                </div>
              )}
            </div>
          </div>
        }
        {/* 혜택권 이미지레일 */}
        {!isAgree && Capacitor.getPlatform() !== 'web' && (
          <AlarmBanner
            clickMarketingButton={() => {
              isMobile() ? openMarketingModal(true) : openMarketingModal(true);
            }}
          />
        )}
        <BookMarkModal
          isOpen={isOpenBookmarkModal}
          setIsOpen={setIsOpenBookMarkModal}
          callback={async () => {
            if (!accessToken) {
              navigator('/login', {
                state: `${location.pathname}${location.search}`,
              });
              return;
            }
            await doLike();
            navigator(`/benefit/${likePopupId}`, {
              state: {
                benefit: info,
              },
            });
          }}
        />
      </div>
    </Layout.BrandCardView>
  );
}
